<app-menu-common url="hr"></app-menu-common>

@if (hrService.backendMissing()) {
	<div class="hr-backend-warn">Serveur non à jour pour les services par établissement (voir docs/backend-brief-hr2.md) : affichage hérité, écritures indisponibles.</div>
}

<!-- Grille de plages PARTAGÉE (services & modèles) : 7 jours + « Copier [jour] vers [jours] » -->
<ng-template #hoursGrid let-vm="vm">
	@for (day of dayLabels; track day; let d = $index) {
		<div class="flexrow hours-day">
			<span class="day-name">{{ day }}</span>
			@for (r of vm.hours[d]; track $index; let i = $index) {
				<span class="range">
					<input type="time" [(ngModel)]="r.start" [ngModelOptions]="{standalone: true}"
						(ngModelChange)="onHoursEdited(vm)" [disabled]="!isAdmin">
					<span class="sep">–</span>
					<input type="time" [(ngModel)]="r.end" [ngModelOptions]="{standalone: true}"
						(ngModelChange)="onHoursEdited(vm)" [disabled]="!isAdmin">
					@if (isAdmin) {
						<button mat-icon-button class="del" (click)="onRemoveHourRange(vm, d, i)" matTooltip="Supprimer la plage" aria-label="Supprimer la plage">
							<mat-icon>close</mat-icon>
						</button>
					}
				</span>
			}
			@if (vm.hours[d].length === 0) {
				<span class="closed">fermé</span>
			}
			@if (isAdmin) {
				<button mat-icon-button class="add" (click)="onAddHourRange(vm, d)" matTooltip="Ajouter une plage" aria-label="Ajouter une plage">
					<mat-icon>add</mat-icon>
				</button>
			}
		</div>
	}
	@if (isAdmin) {
		<div class="flexrow copy-days">
			<span class="copy-label">Copier</span>
			<mat-form-field class="pick-day">
				<mat-select [formControl]="vm.copyFromCtrl">
					@for (day of dayLabels; track day; let d = $index) {
						<mat-option [value]="d + 1">{{ day }}</mat-option>
					}
				</mat-select>
			</mat-form-field>
			<span class="copy-label">vers</span>
			<mat-form-field class="pick-days">
				<mat-select [formControl]="vm.copyToCtrl" multiple placeholder="jours…">
					@for (day of dayLabels; track day; let d = $index) {
						@if (d + 1 !== vm.copyFromCtrl.value) {
							<mat-option [value]="d + 1">{{ day }}</mat-option>
						}
					}
				</mat-select>
			</mat-form-field>
			<button mat-stroked-button type="button" (click)="onCopyDays(vm)"
				[disabled]="!(vm.copyToCtrl.value?.length)">
				<mat-icon>content_copy</mat-icon>&nbsp;Copier
			</button>
		</div>
	}
</ng-template>

<div class="flexrow hr-header">
	<h2>Établissements &amp; services</h2>
	<span class="page-hint">Qui travaille où et quand : services, rôles admis et horaires d'ouverture de chaque établissement.</span>
</div>

<div class="pagecontent org-layout">

	<div class="org-stores">
		@for (svm of storeVMs; track svm.store.id) {
			<section class="org-store">
				<h3>{{ svm.store.name }}</h3>

				@for (vm of svm.activities; track vm.activity.id) {
					<div class="org-activity" [class.legacy]="vm.legacy">
						<div class="flexrow activity-head">
							<!-- Couleur du service : elle l'identifie sur le planning en vue Employés.
							     Enregistrée immédiatement, comme les rôles admis. -->
							<input type="color" class="activity-color" [value]="activityColor(vm)"
								[disabled]="vm.legacy || !isAdmin"
								[matTooltip]="vm.legacy ? 'Service hérité : la couleur se choisira après sa première modification' : 'Couleur de ce service sur le planning'"
								(change)="onActivityColor(vm, $any($event.target).value)"
								[attr.aria-label]="'Couleur du service'">
							<input class="activity-name" [formControl]="vm.nameCtrl" (blur)="onRenameActivity(vm)"
								[readOnly]="!isAdmin" [attr.aria-label]="'Nom du service'">
							@if (vm.legacy) {
								<span class="legacy-chip" matTooltip="Service hérité de l'ancien modèle : la première modification le créera pour de bon.">hérité</span>
							}
							<span class="spacer"></span>
							@if (isAdmin) {
								<button mat-icon-button matTooltip="Supprimer ce service" aria-label="Supprimer ce service" (click)="onDeleteActivity(vm)">
									<mat-icon>delete_outline</mat-icon>
								</button>
							}
						</div>
						<div class="activity-roles">
							@for (r of roles; track r.id) {
								<mat-checkbox [checked]="roleChecked(vm, r.id!)" [disabled]="!isAdmin || vm.saving"
									(change)="onToggleRole(vm, r.id!)">{{ r.name }}</mat-checkbox>
							}
						</div>
						<div class="roles-summary">{{ roleNames(vm) }}</div>

						<div class="flexrow hours-head">
							<button mat-button type="button" class="hours-toggle" (click)="vm.showHours = !vm.showHours">
								<mat-icon>schedule</mat-icon>&nbsp;{{ hoursSummary(vm) }}
								<mat-icon>{{ vm.showHours ? 'expand_less' : 'expand_more' }}</mat-icon>
							</button>
						</div>
						@if (vm.showHours) {
							<div class="hours-editor">
								@if (isAdmin && templates.length > 0) {
									<div class="flexrow from-template">
										<mat-form-field class="pick-template">
											<mat-label>Partir d'un modèle…</mat-label>
											<mat-select [formControl]="vm.templateCtrl">
												@for (t of templates; track t.id) {
													<mat-option [value]="t.id">{{ t.name }}</mat-option>
												}
											</mat-select>
										</mat-form-field>
										<button mat-stroked-button type="button" (click)="onApplyTemplateTo(vm)" [disabled]="vm.templateCtrl.value === null">
											Remplir
										</button>
										<span class="copy-label">puis ajustez et enregistrez</span>
									</div>
								}
								<ng-container [ngTemplateOutlet]="hoursGrid" [ngTemplateOutletContext]="{ vm }"></ng-container>
								@if (isAdmin) {
									<div class="flexrow hours-actions">
										<button mat-button type="button" (click)="onSaveAsTemplate(vm)">
											<mat-icon>bookmark_add</mat-icon>&nbsp;Enregistrer comme modèle
										</button>
										<span class="spacer"></span>
										<button mat-flat-button color="primary" type="button" (click)="onSaveHours(vm)" [disabled]="!vm.hoursDirty || vm.saving">
											Enregistrer les horaires
										</button>
									</div>
								}
							</div>
						}
					</div>
				}
				@if (svm.activities.length === 0) {
					<div class="org-empty">Aucun service. Ajoutez « Magasin », « Livraison »…</div>
				}

				@if (isAdmin) {
					<div class="flexrow add-activity">
						<mat-form-field class="wide">
							<mat-label>Nouveau service (ex : Entrepôt &amp; nettoyage)</mat-label>
							<input matInput [formControl]="svm.newNameCtrl" (keyup.enter)="onAddActivity(svm)">
						</mat-form-field>
						<button mat-stroked-button type="button" (click)="onAddActivity(svm)" [disabled]="!svm.newNameCtrl.value">
							<mat-icon>add</mat-icon>&nbsp;Ajouter
						</button>
					</div>
				}
			</section>
		}
	</div>

	<aside class="org-side">
		<section class="org-roles">
			<h3>Rôles de l'entreprise</h3>
			<p class="aside-hint">Le référentiel commun : chaque personne porte un ou plusieurs rôles (page Personnel), chaque service admet certains rôles.</p>
			<!-- LES RÔLES POSÉS PAR LE CODE, EN TÊTE ET HORS DE LA LISTE RANGEABLE. Un module les cite
			     nommément (le board tournées, pour « Livreur ») : ils ne se renomment pas, ne se
			     retirent pas, et ne se déplacent donc pas non plus. Les tenir dans une liste à part
			     est ce qui rend le glissé honnête — dans une liste unique, la ligne « Livreur »
			     s'écarterait au survol pour finalement refuser le dépôt. -->
			@if (systemRoles.length) {
				<ul class="role-list">
					@for (r of systemRoles; track r.id) {
						<li class="flexrow role-row">
							<!-- Cale de la largeur d'une poignée : les libellés de tous les rôles commencent
							     à la même abscisse, qu'ils soient prenables ou non. -->
							<span class="grip-slot"></span>
							<span>{{ r.name }}</span>
							<span class="role-grant" matTooltip="Rôle posé par le code : le module logistique le cite nommément pour désigner les livreurs. Il s'attribue normalement dans Personnel & rôles, mais ne peut être ni renommé, ni retiré, ni déplacé.">système</span>
							<span class="spacer"></span>
						</li>
					}
				</ul>
			}

			<!-- LE RÉFÉRENTIEL DE L'ENTREPRISE — l'ordre se range à la main et s'enregistre (`seq`).
			     Même geste que dans le planning et les horaires types : on prend la ligne par sa
			     poignée, elle monte ou elle descend. L'ordre vaut PARTOUT, le référentiel étant
			     commun : fiches employé, services, filtres. -->
			<ul class="role-list" cdkDropList cdkDropListLockAxis="y" [cdkDropListData]="sortableRoles"
				[cdkDropListDisabled]="!isAdmin" (cdkDropListDropped)="onRoleDrop($event)">
				@for (r of sortableRoles; track r.id) {
					<li class="flexrow role-row" cdkDrag cdkDragLockAxis="y" [cdkDragData]="r"
						[cdkDragDisabled]="!isAdmin" cdkDragPreviewClass="role-preview">
						@if (isAdmin) {
							<!-- Poignée de rangement : à gauche, là où l'œil cherche une prise. Elle n'existe
							     que pour le responsable RH — la garde serveur refuserait l'écriture. -->
							<span class="row-grip" cdkDragHandle
								matTooltip="Glisser pour ranger ce rôle dans la liste (ordre enregistré)"
								[attr.aria-label]="'Déplacer le rôle ' + r.name">
								<mat-icon>drag_indicator</mat-icon>
							</span>
						} @else {
							<span class="grip-slot"></span>
						}
						<span>{{ r.name }}</span>
						<span class="spacer"></span>
						@if (isAdmin) {
							<button mat-icon-button matTooltip="Retirer (désactiver) ce rôle"
								aria-label="Retirer ce rôle" (click)="onRemoveRole(r)">
								<mat-icon>close</mat-icon>
							</button>
						}
					</li>
				}
			</ul>
			@if (isAdmin) {
				<div class="flexrow add-role" [matTooltip]="rolesCardTooltip">
					<mat-form-field class="wide">
						<mat-label>Nouveau rôle</mat-label>
						<input matInput [formControl]="newRoleCtrl" (keyup.enter)="onAddRole()">
					</mat-form-field>
					<button mat-stroked-button type="button" (click)="onAddRole()" [disabled]="!isAdmin || !newRoleCtrl.value">
						<mat-icon>add</mat-icon>&nbsp;Ajouter
					</button>
				</div>
			}
		</section>

		<!-- O05 — équipes : groupes TRANSVERSES, indépendants des établissements et des services. -->
		<section class="org-roles org-teams">
			<h3>Équipes</h3>
			<p class="aside-hint">
				Des groupes libres pour filtrer le planning et le rapport (« équipe livraison »,
				« équipe du samedi »). Une équipe peut mélanger plusieurs établissements : c'est un
				filtre de confort, <b>pas une structure</b> — l'organisation reste celle des services.
			</p>

			@for (t of teams; track t.id) {
				<div class="team" [class.expanded]="teamOpen === t.id">
					<div class="flexrow team-head">
						<button mat-button type="button" class="hours-toggle" (click)="teamOpen = teamOpen === t.id ? null : t.id">
							<mat-icon>{{ teamOpen === t.id ? 'expand_less' : 'expand_more' }}</mat-icon>
							{{ t.name }}
						</button>
						<span class="team-count">{{ t.members.length }} membre{{ t.members.length > 1 ? 's' : '' }}</span>
						<span class="spacer"></span>
						@if (isAdmin) {
							<button mat-icon-button type="button" matTooltip="Supprimer cette équipe" aria-label="Supprimer cette équipe" (click)="onRemoveTeam(t)">
								<mat-icon>close</mat-icon>
							</button>
						}
					</div>

					@if (teamOpen === t.id) {
						<div class="team-members">
							@for (e of employees; track e.id) {
								<mat-checkbox [checked]="isTeamMember(t, e.id)" [disabled]="!isAdmin"
									(change)="onToggleTeamMember(t, e.id, $event.checked)">
									{{ employeeName(e.id) }}
								</mat-checkbox>
							}
							@if (employees.length === 0) {
								<span class="aside-hint">Aucun salarié actif.</span>
							}
						</div>
					}
				</div>
			}

			@if (teams.length === 0) {
				<p class="aside-hint empty">Aucune équipe définie.</p>
			}

			@if (isAdmin) {
				<div class="flexrow add-role">
					<mat-form-field class="wide">
						<mat-label>Nouvelle équipe (ex : Équipe livraison)</mat-label>
						<input matInput [formControl]="newTeamCtrl" (keyup.enter)="onAddTeam()">
					</mat-form-field>
					<button mat-stroked-button type="button" (click)="onAddTeam()" [disabled]="!newTeamCtrl.value">
						<mat-icon>add</mat-icon>&nbsp;Ajouter
					</button>
				</div>
			}
		</section>

		<section class="org-roles org-templates">
			<h3>Modèles d'horaires</h3>
			<p class="aside-hint">Définissez les horaires types une fois (« Horaires magasin », « Samedi »…), appliquez-les aux établissements, puis ajustez service par service.</p>

			@for (t of templates; track t.id) {
				<div class="template" [class.expanded]="t.expanded">
					<div class="flexrow template-head">
						<button mat-button type="button" class="hours-toggle" (click)="t.expanded = !t.expanded">
							<mat-icon>schedule</mat-icon>&nbsp;{{ t.name }}
							<mat-icon>{{ t.expanded ? 'expand_less' : 'expand_more' }}</mat-icon>
						</button>
						<span class="spacer"></span>
						@if (isAdmin) {
							<button mat-icon-button matTooltip="Supprimer ce modèle" aria-label="Supprimer ce modèle" (click)="onDeleteTemplate(t)">
								<mat-icon>delete_outline</mat-icon>
							</button>
						}
					</div>
					@if (t.expanded) {
						<div class="hours-editor">
							<ng-container [ngTemplateOutlet]="hoursGrid" [ngTemplateOutletContext]="{ vm: t }"></ng-container>
							@if (isAdmin) {
								<div class="flexrow hours-actions">
									<button mat-flat-button color="primary" type="button" (click)="onSaveTemplate(t)" [disabled]="!t.hoursDirty">
										Enregistrer le modèle
									</button>
								</div>
								<div class="flexrow apply-row">
									<mat-form-field class="pick-targets">
										<mat-label>Appliquer à…</mat-label>
										<mat-select [formControl]="t.targetsCtrl" multiple>
											@for (target of applyTargets; track target.id) {
												<mat-option [value]="target.id">{{ target.label }}</mat-option>
											}
										</mat-select>
									</mat-form-field>
									<button mat-stroked-button type="button" (click)="onApplyTemplateEverywhere(t)"
										[disabled]="t.applying || !(t.targetsCtrl.value?.length)">
										{{ t.applying ? 'Application…' : 'Appliquer' }}
									</button>
								</div>
							}
						</div>
					}
				</div>
			}
			@if (templates.length === 0) {
				<div class="org-empty">Aucun modèle. Créez-en un ci-dessous, ou depuis un service via « Enregistrer comme modèle ».</div>
			}

			@if (isAdmin) {
				<div class="flexrow add-role">
					<mat-form-field class="wide">
						<mat-label>Nouveau modèle (ex : Horaires magasin)</mat-label>
						<input matInput [formControl]="newTemplateCtrl" (keyup.enter)="onAddTemplate()">
					</mat-form-field>
					<button mat-stroked-button type="button" (click)="onAddTemplate()" [disabled]="!newTemplateCtrl.value">
						<mat-icon>add</mat-icon>&nbsp;Créer
					</button>
				</div>
			}
		</section>
	</aside>

		<!-- Les deux sections qui suivent sont, malgré leur indentation, des enfants DIRECTS de la
		     grille (hors de l'aside) : c'est ce qui leur permet de prendre les deux colonnes, et
		     c'est ce qui permet aux trois panneaux de l'aside de s'empiler d'affilée. -->

		<!-- Référentiel des ABSENCES. En pleine largeur (`org-wide`) : chaque type porte désormais son
		     régime légal ET son plafond annuel, ce qui ne tenait plus dans une colonne étroite. -->
		<section class="org-roles org-abstypes org-wide">
			<h3>Types d'absence</h3>
			<p class="aside-hint">
				Le référentiel des congés et arrêts (fiche employé, page Congés). « Constaté » = saisissable
				directement approuvé ; « sur demande » = passe par la validation.
				Cochez <b>Récupération</b> sur le type qui débite les heures supplémentaires mises en repos :
				les demandes de ce type sont alors plafonnées au compteur du salarié.
			</p>
			<p class="aside-hint">
				La colonne <b>Régime légal</b> décide de ce que la paie fait de l'absence : qui la paie, si
				elle compte comme du travail, si elle acquiert des congés. Un type dont le nom est reconnu
				(« Congés payés », « Arrêt maladie »…) est rattaché tout seul ; sinon, choisissez son régime,
				sans quoi le rapport le traitera prudemment et le signalera comme non qualifié.
			</p>
			<p class="aside-hint">
				Le <b>plafond</b> sert aux congés que la convention accorde au compte-gouttes — « un jour
				rémunéré pour enfant malade, par salarié et par année civile » (CCN 1982). Renseigné, il
				devient un compteur : le salarié voit ce qu'il lui reste au moment de sa demande, et ne peut
				pas poser plus. Le reliquat ne se reporte pas d'une période sur l'autre. Laissez vide pour un
				congé sans plafond.
			</p>
			<!-- Une colonne par attribut, et des colonnes COMMUNES à toutes les lignes : la grille est
			     portée par le <ul>, chaque <li> se contentant d'y verser ses cellules (`display: contents`).
			     En grille par ligne, chaque rangée dimensionnait ses colonnes pour elle seule et rien ne
			     s'alignait d'une ligne à l'autre. Les cellules facultatives (période, ancienneté) sont
			     toujours émises — le @if est À L'INTÉRIEUR — sinon les cellules suivantes remonteraient
			     d'une colonne. -->
			<ul class="abstype-list">
				@for (t of absenceTypes; track t.id) {
					<li class="abstype-row">
						<span class="abstype-cell abstype-id">
							<span class="abstype-dot" [style.background]="absenceTypeColor(t)"></span>
							<span class="abstype-name">{{ t.name }}</span>
							<span class="abstype-kind">{{ absenceTypeKind(t) }}</span>
						</span>

						<span class="abstype-cell abstype-legal">
							<mat-form-field subscriptSizing="dynamic">
								<mat-label>Régime légal</mat-label>
								<mat-select [value]="absenceTypeCode(t)" [disabled]="!isAdmin"
									(selectionChange)="onAbsenceTypeCode(t, $event.value)">
									<mat-option [value]="''">— non qualifié —</mat-option>
									@for (p of absenceCatalog; track p.code) {
										<mat-option [value]="p.code" [matTooltip]="p.note">{{ p.label }}</mat-option>
									}
								</mat-select>
							</mat-form-field>
						</span>

						<!-- Ce que la paie en fait : sa propre colonne, et non plus un `mat-hint` coincé sous
						     le sélecteur. Deux ou trois lignes de renvois d'articles y donnaient à chaque
						     rangée une hauteur différente, pendant que la moitié droite de l'écran restait
						     vide. Ici, le texte prend justement cette place libre. -->
						<p class="abstype-cell abstype-note" [class.warn]="!absenceTypeRecognized(t)">
							{{ absenceTypeLegal(t) }}
						</p>

						<!-- Plafond annuel — saisie validée à la sortie du champ : chaque frappe écrirait le
						     référentiel. Période et ancienneté n'apparaissent qu'une fois un plafond posé. -->
						<span class="abstype-cell abstype-quota">
							<mat-form-field class="tiny">
								<mat-label>Plafond</mat-label>
								<input matInput type="number" min="0" step="0.5" placeholder="—" [disabled]="!isAdmin"
									[value]="absenceQuotaDays(t) ?? ''"
									(change)="onAbsenceQuota(t, 'days', $any($event.target).value)"
									[attr.aria-label]="'Plafond annuel de ' + t.name">
								<span matTextSuffix>j</span>
								@if (!absenceQuotaDays(t)) {
									<mat-hint>{{ absenceQuotaLabel(t) }}</mat-hint>
								}
							</mat-form-field>
						</span>
						<span class="abstype-cell abstype-period">
							@if (absenceQuotaDays(t)) {
								<mat-form-field class="narrow">
									<mat-label>Période</mat-label>
									<mat-select [value]="absenceQuotaPeriod(t)" [disabled]="!isAdmin"
										(selectionChange)="onAbsenceQuota(t, 'period', $event.value)">
										<mat-option value="civil">Année civile</mat-option>
										<mat-option value="reference">Période de référence des congés</mat-option>
									</mat-select>
								</mat-form-field>
							}
						</span>
						<span class="abstype-cell abstype-seniority">
							@if (absenceQuotaDays(t)) {
								<mat-form-field class="tiny">
									<mat-label>Ancienneté</mat-label>
									<input matInput type="number" min="0" step="6" placeholder="0" [disabled]="!isAdmin"
										[value]="absenceQuotaSeniority(t) ?? ''"
										(change)="onAbsenceQuota(t, 'seniority_months', $any($event.target).value)"
										[attr.aria-label]="'Ancienneté exigée pour ' + t.name">
									<span matTextSuffix>mois</span>
								</mat-form-field>
							}
						</span>

						<span class="abstype-cell abstype-flags">
							<mat-checkbox [checked]="isRcrAbsenceType(t)" [disabled]="!isAdmin"
								matTooltip="Ce type débite le compteur d'heures à récupérer (repos compensateur, repos des majorations)"
								(change)="onToggleAbsenceFlag(t, 'rcr', $event.checked)">
								Récupération
							</mat-checkbox>
							<mat-checkbox [checked]="isCorAbsenceType(t)" [disabled]="!isAdmin"
								matTooltip="Ce type solde la contrepartie obligatoire en repos due au-delà du contingent annuel (L3121-30)"
								(change)="onToggleAbsenceFlag(t, 'cor', $event.checked)">
								COR
							</mat-checkbox>
							@if (isAdmin) {
								<button mat-icon-button matTooltip="Retirer (désactiver) ce type" aria-label="Retirer ce type d'absence" (click)="onRemoveAbsenceType(t)">
									<mat-icon>close</mat-icon>
								</button>
							}
						</span>
					</li>
				}
			</ul>
			@if (isAdmin && absenceTypes.length > 0 && !hasRcrAbsenceType) {
				<p class="aside-hint warn">
					Aucun type « Récupération » : les salariés ne peuvent pas poser leurs heures supplémentaires
					en repos. Ajoutez un type (ex. « Récupération ») et cochez la case.
				</p>
			}
			@if (isAdmin) {
				<div class="flexrow add-role">
					<mat-form-field class="wide">
						<mat-label>Nouveau type (ex : Accident du travail)</mat-label>
						<input matInput [formControl]="newAbsenceTypeCtrl" (keyup.enter)="onAddAbsenceType()">
					</mat-form-field>
					<button mat-stroked-button type="button" (click)="onAddAbsenceType()" [disabled]="!newAbsenceTypeCtrl.value">
						<mat-icon>add</mat-icon>&nbsp;Ajouter
					</button>
				</div>
			}
		</section>

		<!-- L1.1 — les réglages dont dépend le rapport de paie. En pleine largeur, et découpés en
		     PANNEAUX : la trentaine de réglages tenait sur plusieurs écrans de haut, si bien qu'on
		     perdait de vue et son sujet et le bouton d'enregistrement. -->
		<section class="org-roles org-payroll org-wide">
			<h3>Règles de paie</h3>
			<p class="aside-hint">
				Décompte des heures, convention collective, seuil et paliers d'heures supplémentaires,
				plage de nuit, titres-restaurant. C'est ce qui alimente l'onglet <b>Rapport</b>.
			</p>

			<!-- Le sommaire : un panneau à la fois. Les réglages restent TOUS dans le même
			     `payrollForm` — masquer un champ ne le retire pas du formulaire, et l'enregistrement
			     porte donc sur l'ensemble, quel que soit le panneau ouvert. -->
			<nav class="payroll-nav">
				@for (p of payrollPanels; track p.key) {
					<button mat-button type="button" [class.on]="payrollPanel === p.key"
						(click)="payrollPanel = p.key">
						<mat-icon>{{ p.icon }}</mat-icon>&nbsp;{{ p.label }}
					</button>
				}
			</nav>

			<!-- `input` remonte de tous les champs texte du panneau : c'est ce qui allume le témoin
			     « modifications non enregistrées » même pour les paliers et majorations, qui vivent
			     dans des tableaux et non dans le formulaire. -->
			<div [formGroup]="payrollForm" class="payroll-form" (input)="payrollForm.markAsDirty()">

					<!-- ─────────── PANNEAU « Décompte & convention » ─────────── -->
					@if (payrollPanel === 'count') {

					<!-- Le réglage qui décide QUI fait foi pour les heures payées et les heures sup. -->
					<h4>Décompte des heures</h4>
					<mat-radio-group formControlName="time_source" class="source-choice">
						<mat-radio-button value="planning">
							<b>Le planning fait foi</b>
							<span class="source-help">
								Les heures payées et les heures supplémentaires sortent du planning. En fin de
								journée, le salarié signale ses écarts avec « Mes heures », et le responsable
								arbitre avec « Clôturer la journée » depuis le planning.
								C'est le mode à choisir <b>sans badgeuse</b>.
							</span>
						</mat-radio-button>
						<mat-radio-button value="clock">
							<b>La pointeuse fait foi</b>
							<span class="source-help">
								Les heures badgées priment dès qu'un pointage existe ; le planning n'est plus
								qu'une prévision et sert de repli les jours sans badge.
							</span>
						</mat-radio-button>
					</mat-radio-group>
					<p class="aside-hint">
						Dans les deux cas, une journée <b>validée</b> à la main l'emporte : l'arbitrage humain
						est toujours le dernier mot.
					</p>

					<!-- ============================================================
					     CONVENTION COLLECTIVE — cherchée dans les bases de l'État
					     ============================================================ -->
					<h4>Convention collective</h4>
					<p class="aside-hint">
						La convention de votre branche complète le code du travail : c'est elle qui fixe votre
						contingent d'heures supplémentaires, votre plafond hebdomadaire, vos majorations.
						Elle est identifiée par un <b>numéro IDCC</b> à quatre chiffres, imprimé sur vos
						bulletins de paie. Cherchez-la par son nom, par son numéro, ou laissez l'annuaire des
						entreprises la retrouver à partir de votre SIRET.
					</p>

					@if (payrollForm.get('idcc')!.value) {
						<!-- Convention retenue : ce que l'établissement applique, et où lire le texte. -->
						<div class="idcc-chosen">
							<div class="flexrow idcc-head">
								<span class="idcc-num">IDCC {{ payrollForm.get('idcc')!.value }}</span>
								<span class="idcc-title">{{ payrollForm.get('idcc_label')!.value || 'Convention sans libellé' }}</span>
								<span class="spacer"></span>
								@if (isAdmin) {
									<button mat-icon-button type="button" matTooltip="Changer de convention" aria-label="Changer de convention" (click)="onClearIdcc()">
										<mat-icon>close</mat-icon>
									</button>
								}
							</div>
							@if (idccChosen) {
								<div class="idcc-official" [matTooltip]="idccChosen.title">{{ idccChosen.title }}</div>
								<div class="idcc-state" [class.eten]="idccChosen.state === 'etendue'"
									[class.closed]="idccChosen.state === 'close'">{{ idccStateLabel(idccChosen) }}</div>
							}
							<div class="flexrow idcc-links">
								<a mat-stroked-button target="_blank" rel="noopener"
									[href]="payrollForm.get('idcc_url')!.value || idccFallbackUrl">
									<mat-icon>gavel</mat-icon>&nbsp;Texte intégral sur Légifrance
								</a>
								@if (payrollForm.get('idcc_pdf')!.value) {
									<a mat-stroked-button target="_blank" rel="noopener" [href]="payrollForm.get('idcc_pdf')!.value">
										<mat-icon>picture_as_pdf</mat-icon>&nbsp;PDF de la convention
									</a>
								}
							</div>
							@if (idccPreset) {
								<!-- Ce que cette convention change par rapport au code du travail. Proposé,
								     jamais appliqué d'office : c'est du droit, le gérant doit le voir passer. -->
								<div class="idcc-preset">
									<div class="preset-head">
										<mat-icon>auto_fix_high</mat-icon>
										Cette convention s'écarte du code du travail sur {{ idccPreset.items.length }} points
									</div>
									<ul>
										@for (it of idccPreset.items; track it.label) {
											<li><b>{{ it.label }}</b> — {{ it.display }} <span class="preset-src">({{ it.source }})</span></li>
										}
									</ul>
									@if (isAdmin) {
										<button mat-stroked-button type="button" (click)="onApplyPreset()">
											Reporter ces valeurs dans les réglages ci-dessous
										</button>
									}
									<p class="aside-hint">
										Vérifiez-les sur le texte avant d'enregistrer : un accord d'entreprise plus
										favorable, ou un avenant récent, l'emporte sur ce que nous connaissons ici.
									</p>
								</div>
							}
							<mat-form-field class="wide">
								<mat-label>Lien vers le PDF de la convention</mat-label>
								<input matInput formControlName="idcc_pdf" placeholder="https://…">
								<mat-hint>
									Facultatif. Légifrance ne publie pas d'adresse de téléchargement stable : ouvrez le
									texte ci-dessus, utilisez son bouton « Télécharger », déposez le PDF où vos salariés
									peuvent le lire, et collez ici son adresse. Le lien apparaîtra sur chaque fiche salarié.
								</mat-hint>
							</mat-form-field>
						</div>
					}

					@if (!payrollForm.get('idcc')!.value) {
						<!-- Recherche 1 — dans le catalogue officiel KALI embarqué (hors ligne). -->
						<mat-form-field class="wide">
							<mat-label>Chercher une convention par son nom ou son numéro</mat-label>
							<input matInput [formControl]="idccSearchCtrl" [matAutocomplete]="idccAuto"
								(input)="onIdccSearch($any($event.target).value)"
								placeholder="médico-technique, optique, pharmacie, 1982…">
							<mat-icon matIconSuffix>search</mat-icon>
							<mat-hint>417 conventions de la base KALI (DILA) — celle qui alimente Légifrance</mat-hint>
						</mat-form-field>
						<mat-autocomplete #idccAuto="matAutocomplete">
							@for (e of idccResults; track e.idcc) {
								<mat-option class="idcc-option" [value]="e.short" (onSelectionChange)="$event.isUserInput && onPickIdcc(e)">
									<span class="opt-idcc">{{ e.idcc }}</span>
									<span class="opt-title">{{ e.short }}</span>
									@if (e.state === 'close') { <span class="opt-closed">texte clos</span> }
								</mat-option>
							}
						</mat-autocomplete>

						<!-- Recherche 2 — dans l'annuaire des entreprises : la convention RÉELLEMENT déclarée. -->
						<div class="flexrow gap company-row">
							<mat-form-field class="wide">
								<mat-label>…ou la retrouver depuis mon entreprise</mat-label>
								<input matInput [formControl]="companyCtrl" placeholder="SIRET, SIREN ou raison sociale"
									(keydown.enter)="onSearchCompany()">
								<mat-hint>
									Interroge l'annuaire des entreprises de l'État (INSEE + déclarations sociales) et
									rend les conventions que vos établissements déclarent.
								</mat-hint>
							</mat-form-field>
							<button mat-stroked-button type="button" (click)="onSearchCompany()" [disabled]="companySearching">
								<mat-icon>travel_explore</mat-icon>&nbsp;{{ companySearching ? 'Recherche…' : 'Chercher' }}
							</button>
						</div>
						@for (c of companyResults; track c.siren) {
							<div class="company-hit">
								<div class="company-name">{{ c.name }} <span class="company-sub">{{ c.city }} · SIREN {{ c.siren }}</span></div>
								@if (c.idcc.length === 0) {
									<span class="company-none">aucune convention déclarée pour cet établissement</span>
								}
								@for (n of c.idcc; track n) {
									<button mat-stroked-button type="button" class="company-idcc" (click)="onPickCompanyIdcc(n)">
										IDCC {{ n }}<span class="company-idcc-title">{{ ' — ' + (idccLabelOf(n) || 'convention hors catalogue') }}</span>
									</button>
								}
							</div>
						}
						@if (companySearched && companyResults.length === 0) {
							<p class="aside-hint">Aucune entreprise trouvée — essayez le SIRET, ou saisissez le numéro IDCC de vos bulletins.</p>
						}

						<!-- Recherche 3 — le numéro à la main, quand on le connaît déjà. -->
						<div class="flexrow gap">
							<mat-form-field class="narrow">
								<mat-label>Numéro IDCC</mat-label>
								<input matInput formControlName="idcc" placeholder="1982" inputmode="numeric" (change)="onIdccNumber()">
								<mat-hint>Le numéro imprimé sur vos bulletins de paie</mat-hint>
							</mat-form-field>
							<mat-form-field class="wide">
								<mat-label>Nom de la convention</mat-label>
								<input matInput formControlName="idcc_label" placeholder="Négoce et prestations de services médico-techniques">
								<mat-hint>Rempli automatiquement si le numéro figure au catalogue</mat-hint>
							</mat-form-field>
						</div>
					}

					}
					<!-- ─────────── PANNEAU « Heures supplémentaires » (1/2) ─────────── -->
					@if (payrollPanel === 'overtime') {

					<h4>Heures supplémentaires</h4>
					<div class="flexrow gap">
						<mat-form-field class="narrow">
							<mat-label>Seuil hebdomadaire</mat-label>
							<input matInput type="number" min="0" step="0.5" formControlName="week_legal_hours">
							<span matTextSuffix>h</span>
							<mat-hint>Au-delà, les heures d'un temps plein sont majorées. 35 h par défaut</mat-hint>
						</mat-form-field>
						<mat-form-field class="narrow">
							<mat-label>Charges patronales</mat-label>
							<input matInput type="number" min="0" step="1" formControlName="employer_charges_rate">
							<span matTextSuffix>%</span>
							<mat-hint>Sert à estimer le coût employeur dans le rapport</mat-hint>
						</mat-form-field>
					</div>
					<p class="aside-hint">
						Les paliers ci-dessous disent <b>ce qui arrive</b> aux heures au-delà du seuil. Le supplétif
						est 25 % de la 36ᵉ à la 43ᵉ heure, puis 50 % au-delà ; un accord peut prévoir autant de
						paliers qu'il veut, à d'autres taux — jamais sous {{ legal.MIN_OVERTIME_RATE }} % pour des
						heures <b>majorées</b>. La convention HCR, par exemple, en compte trois : 10 %, 20 %, 50 %.
						Le dernier palier reste ouvert (« ∞ ») pour qu'aucune heure haute n'échappe au calcul.
					</p>
					<p class="aside-hint">
						Toutes les heures au-delà du seuil ne se majorent pas : celles qui partent en <b>jours de
						RTT</b>, celles qui rattrapent une fermeture (<b>récupération</b>, L3121-50) et celles d'un
						horaire d'<b>équivalence</b> se paient au taux normal et ne consomment pas le contingent.
						Choisissez le régime dans la colonne « Régime ».
					</p>

					@for (t of overtimeTiers; track $index) {
						<div class="flexrow gap tier">
							<span class="tier-label">De</span>
							<mat-form-field class="tiny">
								<input matInput type="number" min="0" step="0.5" [(ngModel)]="t.from_hours" [ngModelOptions]="{ standalone: true }">
								<span matTextSuffix>h</span>
							</mat-form-field>
							<span class="tier-label">à</span>
							<mat-form-field class="tiny">
								<input matInput type="number" min="0" step="0.5" [(ngModel)]="t.to_hours" [ngModelOptions]="{ standalone: true }" placeholder="∞">
								<span matTextSuffix>h</span>
							</mat-form-field>
							<mat-form-field class="narrow">
								<mat-label>Régime</mat-label>
								<mat-select [(ngModel)]="t.kind" [ngModelOptions]="{ standalone: true }" (selectionChange)="onTierKindChange(t)">
									@for (k of tierKinds; track k.value) {
										<mat-option [value]="k.value" [matTooltip]="k.hint">{{ k.label }}</mat-option>
									}
								</mat-select>
							</mat-form-field>
							<mat-form-field class="tiny">
								<mat-label>Majoration</mat-label>
								<input matInput type="number" min="0" step="5" [(ngModel)]="t.rate" [ngModelOptions]="{ standalone: true }"
									[disabled]="t.kind !== 'paid'">
								<span matTextSuffix>%</span>
							</mat-form-field>
							<mat-form-field class="wide">
								<mat-label>Libellé conventionnel (facultatif)</mat-label>
								<input matInput [(ngModel)]="t.label" [ngModelOptions]="{ standalone: true }"
									placeholder="36e à 39e heure">
							</mat-form-field>
							<button mat-icon-button type="button" matTooltip="Retirer ce palier" aria-label="Retirer ce palier" (click)="onRemoveOvertimeTier($index)">
								<mat-icon>close</mat-icon>
							</button>
						</div>
					}
					<button mat-stroked-button type="button" (click)="onAddOvertimeTier()">
						<mat-icon>add</mat-icon>&nbsp;Ajouter un palier
					</button>

					}
					<!-- ─────────── PANNEAU « Congés & jours fériés » (1/2) ─────────── -->
					@if (payrollPanel === 'leave') {

					<!-- JOURS FÉRIÉS — le calendrier vient de la source officielle (calendrier.api.gouv.fr,
					     Etalab) et se rafraîchit tout seul ; la décision d'ouvrir, elle, appartient à
					     l'établissement, jour par jour, et survit aux rafraîchissements. -->
					<h4>Jours fériés</h4>
					<div class="flexrow gap">
						<mat-form-field class="narrow">
							<mat-label>Zone</mat-label>
							<mat-select [formControl]="holidayForm.controls.zone">
								@for (z of holidayZones; track z) {
									<mat-option [value]="z">{{ z }}</mat-option>
								}
							</mat-select>
							<mat-hint>L'Alsace-Moselle a deux fériés de plus</mat-hint>
						</mat-form-field>
						<mat-form-field class="tiny">
							<mat-label>Rafraîchir tous les</mat-label>
							<input matInput type="number" min="1" step="1" [formControl]="holidayForm.controls.refresh_days">
							<span matTextSuffix>j</span>
						</mat-form-field>
						<mat-form-field class="tiny">
							<mat-label>Horizon</mat-label>
							<input matInput type="number" min="1" max="36" step="1" [formControl]="holidayForm.controls.horizon_months">
							<span matTextSuffix>mois</span>
						</mat-form-field>
						<button mat-stroked-button type="button" (click)="onRefreshHolidays()" [disabled]="holidayRefreshing">
							<mat-icon>cloud_download</mat-icon>&nbsp;{{ holidayRefreshing ? 'Téléchargement…' : 'Rafraîchir' }}
						</button>
						<span class="tier-label">{{ holidaySourceLabel }}</span>
					</div>
					<mat-checkbox [formControl]="holidayForm.controls.open_default">
						Par défaut, l'établissement OUVRE les jours fériés
					</mat-checkbox>
					<p class="aside-hint">
						Un jour férié <b>chômé</b> ne se rattrape pas : les heures que la personne aurait faites
						lui restent acquises, la semaine n'affiche donc ni déficit ni heures supplémentaires.
						Ce sont les <b>horaires prévus ce jour-là</b> qui disent combien d'heures il représente —
						9 h prévues valent 9 h, pas la moyenne ; la base journalière ({{ dayBaseLabel }}) ne sert
						que si aucune grille ne couvre ce jour. Un férié <b>travaillé</b> se compte comme du
						travail, avec sa majoration si vous en avez défini une ci-dessous.
					</p>

					<p class="aside-hint">
						Un férié <b>ouvert</b> se règle jour par jour : ce qu'il paie en plus, et ce qu'il ouvre
						en <b>récupération</b>. Les deux se cumulent — « le 1ᵉʳ mai, +100 % de salaire <i>et</i>
						100 % du temps à récupérer » s'écrit ici tel quel. Laissez un champ vide pour suivre la
						règle générale des jours fériés ({{ holidayDefaultLabel }}), définie plus bas dans
						« Toutes les autres majorations ». Le <b>1ᵉʳ mai</b> ne descend jamais sous
						<b>100 %</b> : c'est la loi (L3133-6), pas un réglage.
					</p>

					@if (holidayDays.length > 0) {
						<!-- Les fériés ont leur propre témoin de modification (`holidayDirty`) : on retient
						     ici leurs événements de saisie pour qu'ils n'allument pas, en plus, celui des
						     règles de paie. -->
						<div class="holiday-grid" (input)="$event.stopPropagation()">
							<!-- En-tête de colonnes : les deux champs ne sont là que sur les jours ouverts, et
							     leur seul <mat-label> obligeait à lire chaque ligne pour savoir lequel paie et
							     lequel récupère. Dit une fois en haut, la liste se lit en colonnes. -->
							<div class="holiday-row holiday-head">
								<span class="holiday-dat">Date</span>
								<span class="holiday-label">Jour férié</span>
								<span class="holiday-rate">Majoration</span>
								<span class="holiday-rest">Récupération</span>
								<span class="holiday-open">Ouverture</span>
							</div>
							@for (day of holidayDays; track day.dat) {
								<div class="holiday-row">
									<span class="holiday-dat">{{ day.dat | date:'EEE d MMM y':'':'fr-FR' }}</span>
									<span class="holiday-label">{{ day.label }}</span>
									@if (day.open) {
										<mat-form-field class="holiday-rate" subscriptSizing="dynamic"
											matTooltip="Ce que la journée paie en plus. Vide = règle générale des jours fériés.">
											<input matInput type="number" min="0" step="5" placeholder="générale"
												[value]="day.rate ?? ''" (input)="onHolidayRate(day, 'rate', $any($event.target).value)"
												[attr.aria-label]="'Majoration du ' + day.label">
											<span matTextSuffix>%</span>
											@if (holidayRateFloor(day); as floor) {
												<mat-hint>minimum {{ floor }} % — L3133-6</mat-hint>
											}
										</mat-form-field>
										<mat-form-field class="holiday-rest" subscriptSizing="dynamic"
											matTooltip="Part du temps travaillé rendue en repos. Vide = règle générale des jours fériés.">
											<input matInput type="number" min="0" step="25" placeholder="générale"
												[value]="day.rest_rate ?? ''" (input)="onHolidayRate(day, 'rest_rate', $any($event.target).value)"
												[attr.aria-label]="'Temps récupéré du ' + day.label">
											<span matTextSuffix>%</span>
										</mat-form-field>
									}
									<mat-slide-toggle class="holiday-open" [checked]="day.open"
										(change)="onToggleHolidayOpen(day, $event.checked)"
										[matTooltip]="day.open ? 'Ouvert : journée travaillée' : 'Chômé : heures maintenues'">
										{{ day.open ? 'Ouvert' : 'Chômé' }}
									</mat-slide-toggle>
								</div>
							}
						</div>
					} @else {
						<p class="aside-hint">Calendrier non chargé — « Rafraîchir » va le chercher.</p>
					}

					<!-- La base journalière : ce que vaut UNE journée dans l'entreprise. Même arithmétique
					     que les congés payés (5 semaines par an : 30 j ouvrables ou 25 j ouvrés selon
					     l'unité réglée), et sert à valoriser un jour d'absence dans l'assiette des heures
					     supplémentaires. -->
					<h4>Base d'une journée</h4>
					<div class="flexrow gap">
						<mat-form-field class="narrow">
							<mat-label>Jours travaillés par semaine</mat-label>
							<input matInput type="number" min="1" max="7" step="1" formControlName="week_working_days">
							<span matTextSuffix>j</span>
						</mat-form-field>
						<span class="tier-label">
							soit une base de <b>{{ dayBaseLabel }}</b> par jour
						</span>
					</div>
					<p class="aside-hint">
						C'est la même arithmétique que les congés payés, qui se décomptent ici en <b>jours
						{{ leaveUnitLabel }}</b> : 5 semaines par an font <b>{{ leaveRules.max_days }} jours</b>,
						soit les <b>{{ leaveMonthlyLabel }} j/mois</b> appliqués sur les fiches. Une journée de
						congé vaut donc {{ dayBaseLabel }}, et ce qui dépasse dans la semaine devient des heures
						supplémentaires — deux jours de 8 h après trois jours de congés font 37 h, donc 2 h en plus.
						<br>L'unité de décompte se règle plus bas, dans <b>Congés payés</b>.
					</p>
					<mat-form-field class="wide">
						<mat-label>Valorisation d'un jour d'absence</mat-label>
						<mat-select formControlName="leave_valuation">
							<mat-option value="day_base">À la base journalière ({{ dayBaseLabel }}) — recommandé</mat-option>
							<mat-option value="planned">Aux heures que le planning prévoyait ce jour-là</mat-option>
						</mat-select>
						<mat-hint>La base journalière vaut même sans créneau saisi ; le planning, lui, donnerait zéro</mat-hint>
					</mat-form-field>

					<!-- Le point de droit qui a changé : depuis Cass. soc. 10 sept. 2025 (confirmé le
					     7 janv. 2026), les heures de congés payés comptent dans l'assiette. -->
					<h4>Congés payés et heures supplémentaires</h4>
					<mat-radio-group formControlName="overtime_leave_basis" class="source-choice">
						<mat-radio-button value="worked_plus_paid_leave">
							<b>Les congés payés comptent dans l'assiette</b>
							<span class="source-help">
								Une semaine avec un jour de congé peut donc générer des heures supplémentaires,
								et ne crée jamais d'heures manquantes. C'est ce qu'impose la Cour de cassation
								depuis le 10 septembre 2025 (n° 23-14.455).
							</span>
						</mat-radio-button>
						<mat-radio-button value="worked">
							<b>Seules les heures réellement travaillées comptent</b>
							<span class="source-help">
								L'ancien décompte. À ne choisir que si un accord collectif ou un usage établi le
								prévoit — et il ne doit pas dissuader le salarié de prendre ses congés.
							</span>
						</mat-radio-button>
					</mat-radio-group>

					}
					<!-- ─────────── PANNEAU « Heures supplémentaires » (2/2) ─────────── -->
					@if (payrollPanel === 'overtime') {

					<h4>Contingent annuel et contrepartie obligatoire en repos (COR)</h4>
					<p class="aside-hint">
						Le <b>contingent</b> est le volume d'heures supplémentaires qu'un salarié peut faire dans
						l'année sans formalité : <b>220 h</b> à défaut d'accord, et tout autre chiffre si un
						accord le prévoit — 130 h en CCN 1982, 270 h dans certains accords du BTP.
					</p>
					<p class="aside-hint">
						Au-delà, chaque heure ouvre une <b>contrepartie obligatoire en repos</b> qui s'ajoute à
						sa majoration — elle ne la remplace pas : l'heure est payée <i>et</i> elle donne du
						repos. Le taux dépend de l'<b>effectif</b>, pas d'un choix : 50 % jusqu'à 20 salariés,
						100 % au-delà (L3121-30). Le repos acquis alimente le compteur d'heures à récupérer, et
						doit être pris dans les <b>2 mois</b>. Dès 7 h acquises, le salarié doit en être informé.
					</p>
					<div class="flexrow gap">
						<mat-form-field class="narrow">
							<mat-label>Contingent annuel</mat-label>
							<input matInput type="number" min="0" step="10" formControlName="contingent_year_h">
							<span matTextSuffix>h</span>
							<mat-hint>220 h sans accord — 130 h en CCN 1982, 270 h en BTP</mat-hint>
						</mat-form-field>
						<mat-form-field class="narrow">
							<mat-label>Contrepartie obligatoire</mat-label>
							<mat-select formControlName="cor_rate">
								<mat-option [value]="50">50 % — 20 salariés au plus</mat-option>
								<mat-option [value]="100">100 % — plus de 20 salariés</mat-option>
							</mat-select>
							<mat-hint>Repos dû par heure faite hors contingent</mat-hint>
						</mat-form-field>
						@if (!corRateMatchesStaff) {
							<button mat-stroked-button type="button" (click)="onApplyCorRate()"
								matTooltip="Le taux découle de l'effectif : c'est la loi qui le fixe, pas l'employeur">
								<mat-icon>groups</mat-icon>&nbsp;{{ staffCount }} salariés inscrits ⇒ passer à {{ corRateForStaff }} %
							</button>
						}
						<mat-form-field class="narrow">
							<mat-label>Plafond conventionnel/semaine</mat-label>
							<input matInput type="number" min="0" max="48" step="1" formControlName="max_week_conventional_hours" placeholder="48">
							<span matTextSuffix>h</span>
							<mat-hint>Le maximum que VOTRE convention autorise sur une semaine. Vide = celui de la loi</mat-hint>
						</mat-form-field>
						<mat-form-field class="narrow">
							<mat-label>Moyenne sur 12 semaines</mat-label>
							<input matInput type="number" min="0" max="46" step="1" formControlName="max_week_avg12_hours">
							<span matTextSuffix>h</span>
							<mat-hint>44 h ; jusqu'à 46 h par accord de branche</mat-hint>
						</mat-form-field>
					</div>

					<h4>Que fait l'entreprise de ses heures supplémentaires ?</h4>
					<mat-radio-group formControlName="overtime_policy" class="source-choice"
						(change)="onOvertimePolicy($any($event).value)">
						<mat-radio-button value="pay">
							<b>Elles sont payées</b>
							<span class="source-help">
								Le cas général, et celui de la loi à défaut d'accord : chaque heure au-delà du
								seuil se paie avec sa majoration.
							</span>
						</mat-radio-button>
						<mat-radio-button value="rest">
							<b>Elles ne sont pas payées : elles sont toutes récupérées</b>
							<span class="source-help">
								L'entreprise ne règle pas les heures supplémentaires — elles alimentent
								automatiquement le <b>compteur d'heures à récupérer</b>, majoration comprise :
								1 h à +25 % donne 1 h 15 de repos, 1 h à +50 % donne 1 h 30. Le salarié les pose
								ensuite comme un congé. Il faut pour cela un accord collectif, ou — sans délégué
								syndical — une décision de l'employeur que le CSE ne conteste pas (L3121-37).
							</span>
						</mat-radio-button>
						<mat-radio-button value="choose">
							<b>On décide au cas par cas</b>
							<span class="source-help">
								Certaines heures se paient, d'autres se récupèrent. Le rapport de paie propose,
								et le responsable RH tranche colonne par colonne.
							</span>
						</mat-radio-button>
					</mat-radio-group>
					@if (overtimePolicy === 'choose') {
						<div class="flexrow gap">
							<mat-form-field class="wide">
								<mat-label>Qui choisit entre payer et récupérer</mat-label>
								<mat-select formControlName="rcr_decider">
									<mat-option value="employer">L'employeur décide</mat-option>
									<mat-option value="employee">Le salarié décide</mat-option>
									<mat-option value="half">Moitié salarié, moitié employeur (CCN 1982)</mat-option>
								</mat-select>
								<mat-hint>Suivez votre convention — le rapport de paie propose ensuite tout seul</mat-hint>
							</mat-form-field>
							<mat-form-field class="narrow">
								<mat-label>Choix par défaut de l'employeur</mat-label>
								<mat-select formControlName="rcr_employer_default">
									<mat-option value="pay">Payer</mat-option>
									<mat-option value="rest">Récupérer</mat-option>
								</mat-select>
								<mat-hint>Ce qui est proposé sur SA part, sans décision contraire</mat-hint>
							</mat-form-field>
						</div>
						<p class="aside-hint">
							Quand c'est le <b>salarié</b> qui décide, sa préférence se règle sur sa fiche
							(Personnel ▸ la personne ▸ « Heures supplémentaires »). Dans tous les cas, le
							responsable RH garde la main dans le récapitulatif du mois, ligne par ligne.
						</p>
					}

					<h4>Temps partiel — heures complémentaires</h4>
					<p class="aside-hint">
						Un contrat sous 35 h ne fait pas d'heures supplémentaires mais des heures
						<b>complémentaires</b>, majorées dès la première. Les seuils se calculent en pourcentage
						<b>du contrat de chacun</b> : pour 10 h/semaine, « 10 % » = la 11ᵉ heure.
					</p>
					<mat-form-field class="wide">
						<mat-label>Plafond des heures complémentaires</mat-label>
						<mat-select formControlName="complementary_limit_ratio">
							<mat-option [value]="0.1">1/10 du contrat — sans accord (L3123-28)</mat-option>
							<mat-option [value]="0.3333333333333333">1/3 du contrat — avec accord de branche ou d'entreprise</mat-option>
						</mat-select>
					</mat-form-field>
					@for (t of partTimeTiers; track $index) {
						<div class="flexrow gap tier">
							<span class="tier-label">Jusqu'à</span>
							<mat-form-field class="tiny">
								<input matInput type="number" min="0" max="33.4" step="0.1" [(ngModel)]="t.to_percent" [ngModelOptions]="{ standalone: true }">
								<span matTextSuffix>%</span>
							</mat-form-field>
							<span class="tier-label">du contrat, majoration</span>
							<mat-form-field class="tiny">
								<input matInput type="number" min="10" step="5" [(ngModel)]="t.rate" [ngModelOptions]="{ standalone: true }">
								<span matTextSuffix>%</span>
							</mat-form-field>
							<button mat-icon-button type="button" matTooltip="Retirer ce palier" aria-label="Retirer ce palier" (click)="onRemovePartTimeTier($index)">
								<mat-icon>close</mat-icon>
							</button>
						</div>
					}
					<button mat-stroked-button type="button" (click)="onAddPartTimeTier()">
						<mat-icon>add</mat-icon>&nbsp;Ajouter un palier
					</button>

					}
					<!-- ─────────── PANNEAU « Majorations » (1/2) ─────────── -->
					@if (payrollPanel === 'premium') {

					<h4>Toutes les autres majorations</h4>
					<p class="aside-hint">
						Nuit, dimanche, fériés — et tout ce que votre convention ajoute : un samedi majoré, une
						plage horaire, les heures au-delà d'une amplitude quotidienne. Elles se
						<b>cumulent</b> avec les heures supplémentaires.
					</p>
					<p class="aside-hint">
						Deux contreparties possibles, et elles se cumulent aussi. La <b>majoration</b> se paie ;
						la <b>récupération</b> crédite le compteur d'heures à récupérer, en pourcentage du temps
						travaillé. « Le dimanche, +17 % et 100 % du temps récupéré » se saisit donc
						<b>17</b> et <b>100</b> : le salarié touche 17 % de plus <i>et</i> pose autant d'heures
						de repos qu'il a travaillé ce jour-là. Laissez la récupération à 0 pour une majoration
						qui se paie et rien de plus.
					</p>
					@for (p of premiums; track $index) {
						<div class="flexrow gap tier">
							<mat-form-field class="narrow">
								<mat-label>Libellé</mat-label>
								<input matInput [(ngModel)]="p.label" [ngModelOptions]="{ standalone: true }">
							</mat-form-field>
							<mat-form-field class="narrow">
								<mat-label>Nature</mat-label>
								<mat-select [(ngModel)]="p.kind" [ngModelOptions]="{ standalone: true }"
									(selectionChange)="payrollForm.markAsDirty()">
									@for (k of premiumKinds; track k.value) {
										<mat-option [value]="k.value">{{ k.label }}</mat-option>
									}
								</mat-select>
							</mat-form-field>
							@if (premiumNeeds(p, 'range')) {
								<mat-form-field class="tiny">
									<mat-label>De</mat-label>
									<input matInput type="time" [ngModel]="premiumTime(p, 'from_min')"
										(ngModelChange)="onPremiumTime(p, 'from_min', $event)" [ngModelOptions]="{ standalone: true }">
								</mat-form-field>
								<mat-form-field class="tiny">
									<mat-label>à</mat-label>
									<input matInput type="time" [ngModel]="premiumTime(p, 'to_min')"
										(ngModelChange)="onPremiumTime(p, 'to_min', $event)" [ngModelOptions]="{ standalone: true }">
								</mat-form-field>
							}
							@if (premiumNeeds(p, 'weekday')) {
								<mat-form-field class="narrow">
									<mat-label>Jour</mat-label>
									<mat-select [(ngModel)]="p.weekday" [ngModelOptions]="{ standalone: true }">
										@for (d of weekdayChoices; track d.value) {
											<mat-option [value]="d.value">{{ d.label }}</mat-option>
										}
									</mat-select>
								</mat-form-field>
							}
							@if (premiumNeeds(p, 'over')) {
								<mat-form-field class="tiny">
									<mat-label>Au-delà de</mat-label>
									<input matInput type="number" min="0" step="30" [(ngModel)]="p.over_min" [ngModelOptions]="{ standalone: true }">
									<span matTextSuffix>mn</span>
								</mat-form-field>
							}
							<mat-form-field class="tiny">
								<mat-label>Majoration</mat-label>
								<input matInput type="number" min="0" step="5" [(ngModel)]="p.rate" [ngModelOptions]="{ standalone: true }">
								<span matTextSuffix>%</span>
								<mat-hint>payée</mat-hint>
							</mat-form-field>
							<mat-form-field class="tiny">
								<mat-label>Récupération</mat-label>
								<input matInput type="number" min="0" step="25" [(ngModel)]="p.rest_rate" [ngModelOptions]="{ standalone: true }">
								<span matTextSuffix>%</span>
								<mat-hint>du temps travaillé</mat-hint>
							</mat-form-field>
							<button mat-icon-button type="button" matTooltip="Retirer cette majoration" aria-label="Retirer cette majoration" (click)="onRemovePremium($index)">
								<mat-icon>close</mat-icon>
							</button>
						</div>
					}
					<button mat-stroked-button type="button" (click)="onAddPremium()">
						<mat-icon>add</mat-icon>&nbsp;Ajouter une majoration
					</button>

					}
					<!-- ─────────── PANNEAU « Congés & jours fériés » (2/2) ─────────── -->
					@if (payrollPanel === 'leave') {

					<h4>Congés payés</h4>
					<p class="aside-hint">
						Le <b>décompte</b> dit ce qu'on retire du compteur quand quelqu'un pose une semaine :
						6 jours en ouvrables (le samedi compte, même fermé), 5 en ouvrés. La <b>période de
						référence</b> est l'année pendant laquelle les droits s'acquièrent ; la <b>période de
						prise</b> celle où le congé principal doit être posé — c'est elle qui décide des jours
						de fractionnement.
					</p>
					<div class="flexrow gap">
						<mat-form-field class="narrow">
							<mat-label>Décompte</mat-label>
							<mat-select formControlName="leave_unit">
								<mat-option value="ouvrables">Jours ouvrables — 2,5/mois, 30 max</mat-option>
								<mat-option value="ouvres">Jours ouvrés — 2,08/mois, 25 max</mat-option>
							</mat-select>
							<mat-hint>Les deux donnent 5 semaines par an</mat-hint>
						</mat-form-field>
						<mat-form-field class="narrow">
							<mat-label>Prise du</mat-label>
							<input matInput formControlName="leave_taking_start" placeholder="05-01">
							<mat-hint>MM-JJ — 05-01 = 1ᵉʳ mai</mat-hint>
						</mat-form-field>
						<mat-form-field class="narrow">
							<mat-label>Prise jusqu'au</mat-label>
							<input matInput formControlName="leave_taking_end" placeholder="10-31">
							<mat-hint>MM-JJ — 10-31 = 31 octobre</mat-hint>
						</mat-form-field>
					</div>

					<!-- ─────────── L'ANNÉE DE CONGÉS ─────────── -->
					<h4>L'année de congés</h4>
					<p class="aside-hint">
						Les congés payés ne se comptent pas par année civile : ils s'acquièrent sur une
						<b>période de référence</b> d'un an et se prennent sur la suivante. Deux années coexistent
						donc en permanence — celle qu'on acquiert (<b>N</b>) et celle qu'on solde (<b>N-1</b>).
						C'est cette date qui commande tout le compteur.
					</p>
					<div class="flexrow gap">
						<mat-form-field class="narrow">
							<mat-label>L'année commence le</mat-label>
							<mat-select formControlName="leave_reference_day" id="leaverefday">
								@for (d of monthDayChoices; track d) {
									<mat-option [value]="d">{{ d }}</mat-option>
								}
							</mat-select>
						</mat-form-field>
						<mat-form-field class="narrow">
							<mat-label>du mois de</mat-label>
							<mat-select formControlName="leave_reference_month" id="leaverefmonth">
								@for (m of monthChoices; track m.value) {
									<mat-option [value]="m.value">{{ m.label }}</mat-option>
								}
							</mat-select>
							<mat-hint>1ᵉʳ juin à défaut d'accord (L3141-3)</mat-hint>
						</mat-form-field>
					</div>
					<div class="leave-year-preview">
						<mat-icon>event_repeat</mat-icon>
						<span>L'année de congés court <b>{{ leaveYearLabel }}</b>.</span>
					</div>

					<h5 class="meal-h5">La clôture de l'année écoulée</h5>
					<p class="aside-hint">
						À la fin de la période, il reste un solde sur N-1 — et il faut décider de son sort :
						<b>reporté</b> sur l'année suivante, <b>perdu</b>, ou <b>payé</b> en indemnité. Ce n'est pas
						un calcul, c'est un arrêté de compte : il s'écrit une fois, il se valide, et il ne bouge
						plus. Tout le reste du compteur, lui, continue de se recalculer depuis les absences.
					</p>
					<mat-checkbox formControlName="leave_closing_enabled" id="leaveclosingenabled">
						Arrêter le compte de l'année écoulée (campagne de clôture)
					</mat-checkbox>
					@if (payrollForm.get('leave_closing_enabled')!.value) {
						<div class="flexrow gap">
							<mat-form-field class="narrow">
								<mat-label>Préavis</mat-label>
								<input matInput type="number" min="0" max="180" step="5" formControlName="leave_closing_notice">
								<span matTextSuffix>j</span>
								<mat-hint>Campagne ouverte dès le {{ leaveClosingOpensLabel }}</mat-hint>
							</mat-form-field>
							<mat-form-field class="narrow">
								<mat-label>Solde restant</mat-label>
								<mat-select formControlName="leave_carryover_default">
									<mat-option value="carry">Reporté sur l'année suivante</mat-option>
									<mat-option value="lost">Perdu</mat-option>
								</mat-select>
								<mat-hint>Ce que le formulaire propose</mat-hint>
							</mat-form-field>
						</div>
						<mat-checkbox formControlName="leave_closing_ack" id="leaveclosingack">
							Demander au salarié de valider son solde
						</mat-checkbox>
						<p class="aside-hint">
							Un report accepté est une preuve ; un report imposé est un litige. Le salarié valide
							depuis son écran Congés — le responsable garde la main pour arrêter le compte.
						</p>
					}
					<!-- TROIS RÉGLAGES INDÉPENDANTS. La renonciation était masquée quand l'attribution était
					     décochée — or c'est l'inverse : ne pas attribuer les jours n'est licite QUE si le
					     salarié y a renoncé (L3141-21). Décocher l'attribution retirait donc la seule case
					     qui rendait la pratique régulière. -->
					<mat-checkbox formControlName="leave_fractionation">
						Attribuer les jours de fractionnement (L3141-23)
					</mat-checkbox>
					<p class="aside-hint">
						+2 jours quand au moins 6 jours du congé principal sont pris hors période, +1 jour entre
						3 et 5. La cinquième semaine n'ouvre pas ce droit.
					</p>
					<mat-checkbox formControlName="leave_waiver_required">
						Proposer au salarié d'y renoncer quand il pose hors période
					</mat-checkbox>
					<p class="aside-hint">
						La renonciation est tracée (qui, quand) : elle vaut accord individuel exprès.
						@if (!payrollForm.get('leave_fractionation')!.value) {
							<b>Les jours n'étant pas attribués, c'est elle qui rend la pratique régulière —
							gardez-la cochée.</b>
						}
					</p>
					<mat-checkbox formControlName="leave_waiver_blocking">
						Refuser la demande hors période sans renonciation
					</mat-checkbox>
					<p class="aside-hint">
						Quand des jours de fractionnement sont dus (3 jours ou plus du congé principal hors
						période), la demande n'est pas enregistrable tant que le salarié n'y a pas
						expressément renoncé. En dessous de 3 jours, aucun droit ne naît : rien n'est bloqué.
					</p>

					}
					<!-- ─────────── PANNEAU « Majorations » (2/2) ─────────── -->
					@if (payrollPanel === 'premium') {

					<h4>Heures particulières</h4>
					<p class="aside-hint">
						La plage de nuit <b>traverse minuit</b> : 21:00 → 06:00 se comprend tout seul.
						Laissez une majoration à 0 pour seulement <i>suivre</i> ces heures sans les majorer —
						elles apparaîtront quand même dans le rapport et l'export comptable.
					</p>
					<div class="flexrow gap">
						<mat-form-field class="narrow">
							<mat-label>Nuit de</mat-label>
							<input matInput type="time" formControlName="night_start">
						</mat-form-field>
						<mat-form-field class="narrow">
							<mat-label>Nuit jusqu'à</mat-label>
							<input matInput type="time" formControlName="night_end">
						</mat-form-field>
						<mat-form-field class="tiny">
							<mat-label>Nuit</mat-label>
							<input matInput type="number" min="0" step="5" formControlName="night_rate">
							<span matTextSuffix>%</span>
						</mat-form-field>
						<mat-form-field class="tiny">
							<mat-label>Dimanche</mat-label>
							<input matInput type="number" min="0" step="5" formControlName="sunday_rate">
							<span matTextSuffix>%</span>
						</mat-form-field>
						<mat-form-field class="tiny">
							<mat-label>Fériés</mat-label>
							<input matInput type="number" min="0" step="5" formControlName="holiday_rate">
							<span matTextSuffix>%</span>
						</mat-form-field>
					</div>

					}
					<!-- ─────────── PANNEAU « Titres-restaurant » ─────────── -->
					@if (payrollPanel === 'meal') {

					<h4>Titres-restaurant</h4>
					<mat-checkbox formControlName="meal_enabled">L'entreprise propose des titres-restaurant</mat-checkbox>
					@if (payrollForm.get('meal_enabled')!.value) {

						<!-- LE MONTANT — d'abord, parce que c'est la question qu'on vient se poser ici. -->
						<h5 class="meal-h5">Combien vaut un titre, et qui paie quoi</h5>
						<div class="flexrow gap">
							<mat-form-field class="narrow">
								<mat-label>Valeur du titre</mat-label>
								<input matInput type="number" min="0" step="0.5" formControlName="meal_face_value">
								<span matTextSuffix>€</span>
								<mat-hint>Valeur faciale : employeur + salarié</mat-hint>
							</mat-form-field>
							<mat-form-field class="narrow">
								<mat-label>Part patronale</mat-label>
								<input matInput type="number" min="0" max="100" step="5" formControlName="meal_employer_share">
								<span matTextSuffix>%</span>
								<mat-hint>Exonérée entre {{ mealShareMin }} et {{ mealShareMax }} %</mat-hint>
							</mat-form-field>
							<mat-form-field class="narrow">
								<mat-label>Plafond d'exonération</mat-label>
								<input matInput type="number" min="0" step="0.01" formControlName="meal_exoneration_cap">
								<span matTextSuffix>€</span>
								<mat-hint>Par titre, revalorisé chaque année</mat-hint>
							</mat-form-field>
						</div>

						<!-- L'aperçu vivant : il bouge pendant qu'on tape. -->
						<div class="meal-preview">
							<div class="meal-part">
								<span class="meal-part-label">L'entreprise paie</span>
								<b>{{ mealEmployerAmount }}</b>
								<span class="meal-part-sub">par titre</span>
							</div>
							<mat-icon>add</mat-icon>
							<div class="meal-part">
								<span class="meal-part-label">Retenu sur le bulletin</span>
								<b>{{ mealEmployeeAmount }}</b>
								<span class="meal-part-sub">part salariale</span>
							</div>
							<span class="meal-optimal">
								Valeur qui épuise le plafond sans le dépasser : <b>{{ mealOptimalFaceValue }}</b>
							</span>
						</div>
						@for (w of mealWarnings; track w.text) {
							<div class="meal-warning" [class.level-error]="w.level === 'error'">
								<mat-icon>{{ w.level === 'error' ? 'gpp_maybe' : 'info' }}</mat-icon>
								<span>{{ w.text }}</span>
							</div>
						}

						<!-- QUAND un titre est dû -->
						<h5 class="meal-h5">Quand un titre est acquis</h5>
						<p class="aside-hint">
							Un titre par journée <b>coupée par le repas</b> : il faut travailler de part et d'autre
							de l'heure du repas, au moins la durée indiquée de chaque côté. Une matinée seule ou une
							après-midi seule n'ouvre aucun droit — pas plus qu'un jour d'absence, de congé ou de repos.
						</p>
						<div class="flexrow gap">
							<mat-form-field class="narrow">
								<mat-label>Heure du repas</mat-label>
								<input matInput formControlName="meal_pivot" placeholder="12:00">
								<mat-hint>La charnière : avant / après</mat-hint>
							</mat-form-field>
							<mat-form-field class="narrow">
								<mat-label>Travail minimum avant</mat-label>
								<input matInput type="number" min="0" step="15" formControlName="meal_morning_min">
								<span matTextSuffix>mn</span>
							</mat-form-field>
							<mat-form-field class="narrow">
								<mat-label>…et après</mat-label>
								<input matInput type="number" min="0" step="15" formControlName="meal_afternoon_min">
								<span matTextSuffix>mn</span>
							</mat-form-field>
						</div>
						<p class="aside-hint">
							Un salarié peut être exclu individuellement depuis sa fiche. Les jours où l'entreprise
							a payé le repas (formation, note de frais, repas d'affaires) se saisissent dans
							<a routerLink="/hr/meals">Titres-restaurant</a> et retirent le titre du jour.
						</p>
					}

					}
					<!-- ─────────── PANNEAU « Ce que la loi impose » ─────────── -->
					@if (payrollPanel === 'legal') {

					<!-- N0 — l'ordre public. Non paramétrable par construction : le montrer évite la
					     question « pourquoi ma saisie de 50 h est-elle ramenée à 48 ? ». -->
					<h4>Ce que la loi impose, quoi que vous saisissiez</h4>
					<div class="legal-floor">
						Ces plafonds bornent tous les réglages, quel que soit le panneau : une valeur plus
						permissive est ramenée à la loi à l'enregistrement, sans avertissement bloquant.
						<b>{{ legal.MAX_DAY_MIN / 60 }} h</b> par jour (L3121-18) ·
						<b>{{ legal.MAX_WEEK_MIN / 60 }} h</b> sur une semaine (L3121-20) ·
						<b>{{ legal.MAX_WEEK_AVG12_MIN / 60 }} h</b> en moyenne sur 12 semaines, {{ legal.MAX_WEEK_AVG12_AGREEMENT_MIN / 60 }} h par accord (L3121-22) ·
						<b>{{ legal.MIN_DAILY_REST_MIN / 60 }} h</b> de repos entre deux journées (L3131-1) ·
						<b>{{ legal.MIN_WEEKLY_REST_MIN / 60 }} h</b> de repos hebdomadaire consécutives (L3132-2) ·
						<b>{{ legal.BREAK_MIN }} min</b> de pause dès {{ legal.BREAK_AFTER_MIN / 60 }} h de travail (L3121-16) ·
						majoration jamais sous <b>{{ legal.MIN_OVERTIME_RATE }} %</b> (L3121-33) ·
						heures complémentaires plafonnées au <b>tiers</b> du contrat (L3123-28).
					</div>

					}

					<!-- BARRE D'ACTION COLLANTE — elle suit le défilement, quel que soit le panneau : le
					     bouton d'enregistrement ne se cherche plus. Les jours fériés s'enregistrent à part
					     (ils partagent le même c_values, mais pas la même saisie) : leur bouton n'apparaît
					     que là où on les a modifiés. -->
					@if (isAdmin) {
						<div class="flexrow payroll-actions">
							@if (payrollForm.dirty) {
								<span class="dirty-flag">
									<mat-icon>edit_note</mat-icon>&nbsp;Modifications non enregistrées
								</span>
							} @else {
								<span class="saved-flag">Réglages à jour</span>
							}
							<span class="spacer"></span>
							@if (holidayDirty) {
								<button mat-stroked-button type="button" (click)="onSaveHolidays()">
									Enregistrer les jours fériés
								</button>
							}
							<button mat-flat-button color="primary" type="button" (click)="onSavePayrollRules()">
								Enregistrer les règles de paie
							</button>
						</div>
					}
			</div>
		</section>

</div>
